import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	const testimonialsSwiper = new Swiper(
		'.testimonials-section-slider-sidebar',
		{
			modules: [Navigation, Pagination, A11y],
			pagination: {
				el: '.testimonials-section-slider-sidebar .swiper-pagination',
				clickable: true,
			},
			a11y: true,
			keyboardControl: true,
			grabCursor: true,
			slidesPerView: 1,
			spaceBetween: 40,
			autoHeight: true,
		}
	);

	//  listen for browser size changes
	window.onresize = function () {
		testimonialsSwiper.update();
	};
};
